import { motion } from 'motion/react';
import { usePersona } from '@/hooks/usePersona';
import { PERSONAS } from '@/types';
import type { PersonaId } from '@/types';
import { lightImpact } from '@/utils/haptics';

const BottomNav = () => {
  const { currentPersona, switchPersona } = usePersona();

  return (
    <nav className="safe-bottom fixed bottom-0 left-0 right-0 z-40 glass-strong border-t border-slate-200/50 dark:border-slate-800/50">
      <div className="max-w-4xl mx-auto px-2">
        <div className="flex items-center justify-around h-20">
          {PERSONAS.map((persona) => {
            const isActive = currentPersona === persona.id;
            return (
              <motion.button
                key={persona.id}
                whileTap={{ scale: 0.88 }}
                onClick={async () => {
                  await lightImpact();
                  switchPersona(persona.id as PersonaId);
                }}
                className={`relative flex flex-col items-center justify-center py-2 px-1 rounded-xl min-h-[48px] min-w-[48px] flex-1 transition-colors duration-200
                  ${isActive ? '' : 'hover:bg-slate-50 dark:hover:bg-slate-800/50'}
                `}
                aria-label={persona.label}
                aria-current={isActive ? 'page' : undefined}
              >
                {/* Active indicator */}
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full gradient-bg"
                    transition={{ type: 'spring', stiffness: 500, damping: 35 }}
                  />
                )}

                <motion.span
                  animate={{
                    scale: isActive ? 1.15 : 1,
                    y: isActive ? -2 : 0,
                  }}
                  transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  className="text-2xl mb-0.5 select-none"
                >
                  {persona.icon}
                </motion.span>
                <span
                  className={`text-[10px] font-semibold leading-tight ${
                    isActive
                      ? 'text-primary-600 dark:text-primary-400'
                      : 'text-slate-400 dark:text-slate-500'
                  }`}
                >
                  {persona.label}
                </span>

                {isActive && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="absolute inset-0 rounded-xl bg-primary-50 dark:bg-primary-900/20 -z-10"
                  />
                )}
              </motion.button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
